import React from "react";
import { avatarColor, initials } from "../utils";
import { PersonIcon } from "./icons";

interface Props {
  name: string;
  isStaff: boolean;
  anonymous: boolean; // identity mode is anonymous and this is not staff
  size?: "lg" | "sm";
}

// Avatar matches the prototype: anonymous → generic person glyph on grey; staff → blue;
// otherwise a name-derived color with initials.
const Avatar: React.FC<Props> = ({ name, isStaff, anonymous, size = "lg" }) => {
  const cls = `pc-avatar pc-avatar-${size}`;
  if (anonymous && !isStaff) {
    return (
      <div className={`${cls} pc-avatar-anon`} aria-hidden="true">
        <PersonIcon />
      </div>
    );
  }
  const bg = isStaff ? "var(--pc-blue)" : avatarColor(name);
  return (
    <div className={cls} style={{ background: bg }} aria-hidden="true">
      {initials(name)}
    </div>
  );
};

export default Avatar;
